import React from 'react'
import {Page} from 'react-onsenui'
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Loader from 'react-loader-spinner';
import {showAlertMessage} from "../../modules/alert";
import {NAVER_LOGIN, NAVER_LOGIN_PRODUCTION} from "../../modules/variable/common_variable";
import {showToastMessage} from "../../modules/toast";


class LoginCallback extends React.Component {
    constructor(props){
        super(props);
        this.movePageTimeOut = null;
    }

    state = {

    };

    componentDidMount() {
        const naverLogin = new window.naver.LoginWithNaverId(
            {
                clientId: process.env.NODE_ENV.toUpperCase() === 'PRODUCTION' ? NAVER_LOGIN_PRODUCTION.clientId: NAVER_LOGIN.clientId,
                callbackUrl: process.env.NODE_ENV.toUpperCase() === 'PRODUCTION' ? NAVER_LOGIN_PRODUCTION.callbackUrl : NAVER_LOGIN.callbackUrl,
                isPopup: false,
                callbackHandle: true
            }
        );
        naverLogin.init();

        window.addEventListener('load', () => {
            naverLogin.getLoginStatus((status) => {
                clearTimeout(this.movePageTimeOut);
                if (status) {
                    localStorage.setItem("EVER_LOGGED_IN", "TRUE");
                    this.props.history.push('/home');
                } else {
                    this.props.showAlertMessage("로그인 과정에서 문제가 발생하였습니다.", "로그인 오류");
                    this.props.history.push('/intro');
                }
            });
        });

        this.movePageTimeOut = setTimeout(() => {
            naverLogin.getLoginStatus((status) => {
                if (status) {
                    this.props.history.push('/home');
                } else {
                    this.props.history.push('/intro');
                }
            });
        }, 3000);
    }

    componentWillReceiveProps(nextProps) {
    }


    render() {
        return (
            <Page>
                <div className='loader-puff'>
                    <Loader type="ThreeDots" color="#00BFFF" height={80} width={80} />
                    <p>로그인 확인중</p>
                </div>
            </Page>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo,
});

const mapDispatchToProps = dispatch => ({
    showToastMessage: message => dispatch(showToastMessage(message)),
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginCallback))